import React, { Fragment, Component } from 'react';
import { loadPost } from '../../actions/post'
import {createCommentLike, createPostLike} from "../../actions/user";
import { connect } from 'react-redux'
import {Icon} from 'antd'
import CommentForm from '../../CommentForm'
import withSizes from 'react-sizes'
import back from '../../images/back.png'
import home from '../../images/home.png'
import history from '../../history'
import './Post.css'
import point from "../../images/point.png"
import comment from "../../images/comment.png"
import Intro from '../../Intro'
import {formatContent} from "../../utils";
import WXConfig from "../../WXConfig";
import {interactPost} from '../../actions/posts';

class Post extends Component {

  componentDidMount(){
    let {match:{params:{_id}}} = this.props
    this.props.loadPost(_id)
  }

  renderPost(post){
    let {myPostLikes, createPostLike} = this.props
    return <div className={"post-container"}>
      <div
        className={"post-header"}
        onClick={(e)=>{
          if(window.location.pathname !== '/users/'+post.user._id && !post.anonymous){
            e.preventDefault()
            e.stopPropagation()
            history.push('/users/'+post.user._id)
          }
        }}
      >
        <span className={"post-head-image"} style={{
          backgroundImage: !post.anonymous && `url(${post.user.headImgUrl})`
        }} />
        <span className={"post-nickname"}>
        {post.anonymous?'匿名':post.user.nickname}
        </span>
      </div>
      <div className={"post-content"}>
        {formatContent(post.content)}
      </div>
      <div className={"post-footer"}>
        <span
          className={"post-like"}
          onClick={myPostLikes[post._id]?()=>{}:createPostLike.bind(null, post._id)}
        >
          <Icon
            type="heart"
            theme={`${myPostLikes[post._id]?'filled':'outlined'}`}
          />赞
        </span>
        <span className={"post-point"} style={{
          backgroundImage: `url(${point})`
        }}>{post.rewards || 0}</span>
        <span className={"post-comment"} style={{
          backgroundImage: `url(${comment})`
        }}>{post.commentsCount || 0}</span>
      </div>
    </div>
  }

  renderComment(comment){
    let {myCommentLikes, createCommentLike} = this.props
    return <div className={"comment-container"} key={comment._id}>
      <div
        className={"comment-header"}
        onClick={(e)=>{
          if(window.location.pathname !== '/users/'+comment.user._id && !comment.anonymous){
            e.preventDefault()
            e.stopPropagation()
            history.push('/users/'+comment.user._id)
          }
        }}
      >
        <span className={"comment-head-image"} style={{
          backgroundImage: !comment.anonymous && `url(${comment.user.headImgUrl})`
        }} />
        <span className={"comment-nickname"}>
        {comment.anonymous?'匿名':comment.user.nickname}
        </span>
      </div>
      <div className={"comment-content"}>
        {formatContent(comment.content)}
      </div>
      <div
        className={"comment-footer"}
        onClick={myCommentLikes[comment._id]?()=>{}:createCommentLike.bind(null, comment._id)}
      >
        <span className={"comment-like"}>
          <Icon
            type="heart"
            theme={`${myCommentLikes[comment._id]?'filled':'outlined'}`}
          />赞
        </span>
        <span className={"comment-point"} style={{
          backgroundImage: `url(${point})`
        }}>{comment.rewards || 0}</span>
      </div>
    </div>
  }

  render() {
    const {
      loadingPost,
      loadingPostError,
      my,
      post,
      comments
    } = this.props
    return <div
      className="home-posts-container"
    >
      {
        (loadingPostError) && <span className={'center danger'}>
          {loadingPostError}
        </span>
      }
      {
        !loadingPostError  && loadingPost && <span className={'center'}>
          <Icon type="loading" className={'loading-icon center'} />
          <span className={'text'}>载入中...</span>
        </span>
      }
      {
        !loadingPostError && !loadingPost && <Fragment>
          <div
            className="home-posts-container"
            onClick={()=>{
              if(post && post._id){
                this.props.interactPost(post._id)
              }
            }}
          >
            <div
              className={"home-posts-back"}
              style={{
                backgroundImage: `url(${back})`
              }}
              onClick = {()=> {
                history.goBack()
              }}
            />
            <div
              className={"home-posts-home"}
              style={{
                backgroundImage: `url(${home})`
              }}
              onClick = {()=> {
                history.push('/')
              }}
            />
            {my && my.weixin &&
            <div
              className={"home-posts-header"}
              style={{
                backgroundImage: `url(${my.weixin.headimgurl})`
              }}
              onClick={()=> {
                history.push('/users/'+my._id)
              }}
            />
            }
            {!post && <span className={'center'}>
                <span className={'text'}>问题不存在</span>
              </span>
            }
            <div className={"post-content-container"}>
            {post && this.renderPost(post)}
            {comments  && comments.map(comment=>this.renderComment(comment))}
            </div>
          </div>
          {post &&
          <CommentForm post={post._id}/>
          }
          {post &&
          <WXConfig
            title={`${post.anonymous?'匿名':post.user.nickname}在「你好，朋友」`}
            desc={(post && post.content) || "你好朋友，我有一个问题"}
            link={window.location.href}
          />
          }
          <Intro />
        </Fragment>
      }
    </div>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    my: state.user.my,
    post: state.post.post,
    myPostLikes: state.user.myPostLikes,
    myCommentLikes: state.user.myCommentLikes,
    comments: state.post.comments,
    loadingPost: state.post.loadingPost,
    loadingPostError: state.post.loadingPostError,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadPost: (_id)=>dispatch(loadPost(_id)),
    interactPost: (_id)=>dispatch(interactPost(_id)),
    createPostLike: (_id)=>dispatch(createPostLike(_id)),
    createCommentLike: (_id)=>dispatch(createCommentLike(_id)),
  }
}

const mapSizesToProps = ({ width, height }) => {
  return {width, height}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSizes(mapSizesToProps)(Post))




// WEBPACK FOOTER //
// ./src/routes/post/Post.js